import axios from 'axios';

const state = {
  list: [],
  fullCount: 0,
  sort: {
    field: 'name',
    direction: 'asc',
  },
  page: {
    pageSize: 30,
    page: 1,
  },
  badges: [],
  social_networks: [],
  restaurants: [],
  dishes: [],
};

const getters = {
  getNetById: st => id => st.social_networks.find(n => n._id === id),
  getBadgeById: st => id => st.badges.find(b => b._id === id),
};

const actions = {
  async getBadges({ commit }) {
    const response = await axios.get(`${process.env.VUE_APP_API_ROOT}/misc/badges`);

    commit('setBadges', response.data);
  },
  async getSocialNetworks({ commit }) {
    const response = await axios.get(`${process.env.VUE_APP_API_ROOT}/misc/socialNetworks`);

    commit('setSocialNetworks', response.data);
  },
  async getSocialNetwork({ commit }, netId) {
    const response = await axios.get(`${process.env.VUE_APP_API_ROOT}/misc/socialNetwork/${netId}`);

    commit('addNet', response.data.social_network);
  },
  async updateNetwork({ commit }, netId) {
    const response = await axios.get(`${process.env.VUE_APP_API_ROOT}/misc/socialNetwork/${netId}`);

    commit('updateNet', response.data.social_network);
  },
  async getRestaurants({ commit }) {
    const response = await axios.get(`${process.env.VUE_APP_API_ROOT}/misc/restaurants`);

    commit('setRestaurants', response.data);
  },
  async getDishes({ commit, state: st }) {
    let url = `${process.env.VUE_APP_API_ROOT}/misc/dishes`;
    url += `?paging=true&page=${st.page.page}&pageSize=${st.page.pageSize}`;

    if (st.sort.field) {
      url += `&sorting=true&sortField=${st.sort.field}&sortDirection=${st.sort.direction}`;
    }

    if (st.filter && st.filter !== '') {
      url += `&filtering=true&filter=${st.filter}`;
    }
    const response = await axios.get(url);

    commit('setDishes', response.data);
    commit('setCount', response.data.count);
  },
  async getDish({ commit }, dishId) {
    const response = await axios.get(`${process.env.VUE_APP_API_ROOT}/misc/dishes/${dishId}`);

    commit('addDish', response.data.dishes);
  },
  async updateDish({ commit }, dishId) {
    const response = await axios.get(`${process.env.VUE_APP_API_ROOT}/misc/dishes/${dishId}`);

    commit('updateDish', response.data.dishes);
  },
  async sortDishes({ commit, state: st, dispatch }, field) {
    if (st.sort && st.sort.field === field) {
      if (st.sort.direction === 'ASC') {
        commit('setSortDirection', 'DESC');
      } else if (st.sort.direction === 'DESC') {
        commit('setSortDirection', 'ASC');
      }
    } else {
      commit('setSortDirection', 'ASC');
      commit('setSortField', field);
    }

    await dispatch('getDishes');
  },
  async setPage({ commit, dispatch }, page) {
    commit('setPage', page);
    await dispatch('getDishes');
  },
  setFilter({ commit }, filter) {
    commit('setFilter', filter);
  },
  setType({ commit }, type) {
    commit('setType', type);
  },
  resetFilter({ commit }) {
    commit('setFilter', '');
    commit('setType', '');
  },
};

const mutations = {
  setBadges(st, badges) {
    st.badges = badges;
  },
  setSocialNetworks(st, networks) {
    st.social_networks = networks;
  },
  addNet(st, net) {
    st.social_networks.push(net);
  },
  updateNet(st, net) {
    const i = st.social_networks.findIndex(n => n._id === net._id);
    if (i > 0) {
      st.social_networks[i] = net;
    } else {
      st.social_networks.push(net);
    }
  },
  setRestaurants(st, restaurants) {
    st.restaurants = restaurants;
  },
  setDishes(st, dishes) {
    st.dishes = dishes;
  },
  addDish(st, dish) {
    st.dishes.push(dish);
  },
  updateDish(st, dish) {
    const i = st.dishes.findIndex(d => d._id === dish._id);
    if (i > 0) {
      st.dishes[i] = dish;
    } else {
      st.dishes.push(dish);
    }
  },
  setCount(st, count) {
    st.fullCount = count;
  },
  setSortField(st, field) {
    st.sort.field = field;
  },
  setSortDirection(st, direction) {
    st.sort.direction = direction;
  },
  setPage(st, page) {
    st.page.page = page;
  },
  setFilter(st, filter) {
    st.filter = filter;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
